export const uk = {
    'selected-groups-count': {
        one: 'Вибрана {count} категорія',
        some: 'Вибрано {count} категорії',
        many: 'Вибрано {count} категорій',
        none: 'Вибір категорій'
    },
    'video-preview-header': 'Попередній перегляд',
    'video-title': 'Бібліотека відеороликів'
};
